export default "__VITE_ASSET__DmtM_g1a__"